import { getFilesByType, strings } from "@quickpoint.me/shared";
import { useRecoilRefresher_UNSTABLE, useRecoilValue } from "recoil";
import {
	fireUpdateAppVarsEvent,
	fireUpdateBackLinksEvent,
	fireUpdateCodeEvent,
	fireUpdateDataFilesEvent,
	fireUpdateFilterNamesEvent,
	fireUpdateImageFilesEvent,
} from "../../lib/editor/events";
import {
	BackLinksSelector,
	StackId,
	StackSelectorFamily,
} from "../../state/stackSelectors";

import { useEffect } from "react";
import { OwnerName } from "../../state/authSelectors";
import { AllFiles } from "../../state/files";
import { FilterNamesSelector } from "../../state/filters";
import { StackCfKeyAtom } from "../../state/stackAtoms";
import { CodeMirrorIsReady } from "../../state/uiAtoms";

function CodeMirrorRecoilStateController() {
	const stackCfKey = useRecoilValue(StackCfKeyAtom);
	const codeMirrorIsReady = useRecoilValue(CodeMirrorIsReady);
	const allFiles = useRecoilValue(AllFiles);
	const backLinks = useRecoilValue(BackLinksSelector);
	const filterNames = useRecoilValue(FilterNamesSelector);
	const stackId = useRecoilValue(StackId);
	const refresh = useRecoilRefresher_UNSTABLE(
		StackSelectorFamily(stackCfKey ? stackCfKey : strings.unset),
	);
	const stack = useRecoilValue(
		StackSelectorFamily(stackCfKey ? stackCfKey : strings.unset),
	);
	const ownerName = useRecoilValue(OwnerName); // use this to trigger a refresh after login in
	const dataFiles = getFilesByType("data", allFiles);
	const imageFiles = getFilesByType("image", allFiles);

	// initialize when codemirror is ready
	useEffect(() => {
		if (codeMirrorIsReady === 0) return;
		fireUpdateDataFilesEvent(dataFiles);
		fireUpdateImageFilesEvent(imageFiles);
		fireUpdateBackLinksEvent(backLinks);
		fireUpdateFilterNamesEvent(filterNames);
		fireUpdateAppVarsEvent({ stackCfKey, stackId });
		fireUpdateCodeEvent(stack.code, true);
	}, [
		codeMirrorIsReady,
		stackId,
		stack.code,
		dataFiles,
		imageFiles,
		backLinks,
		filterNames,
		stackCfKey,
	]);

	// on init the StackAtomFamily state is not set as the use isn't ready. This effect refreshes the stack
	// an forces the StackAtomFamily to re-init and contact the backend as the user is now ready.
	useEffect(() => {
		refresh();
	}, [ownerName]);

	// update any codemirror state that is not the document at any time.
	useEffect(() => {
		if (codeMirrorIsReady === 0) return;
		fireUpdateDataFilesEvent(dataFiles);
		fireUpdateImageFilesEvent(imageFiles);
		fireUpdateBackLinksEvent(backLinks);
		fireUpdateFilterNamesEvent(filterNames);
	}, [codeMirrorIsReady, dataFiles, imageFiles, backLinks, filterNames]);

	return <></>;
}

export default CodeMirrorRecoilStateController;
